import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the plugin
import { GetCandidatePie } from "../../../../apiServices";
import AdminPieChartFilter from "./AdminPieChartFilter";
import ModalContainer from "../../../../components/modal_popup";
import { DMMMYYYY_formate, MyModal } from "../../../../utility";
import { useSelector } from "react-redux";

// Register components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels); // Register the datalabels plugin

function AdminCandidatePieChart() {
  const JobsFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard
  );
  const startDate = useSelector(
    (state) =>
      state.CandidateDashboardFilterDetails.CandidateDashboard.startDate
  );
  const endDate = useSelector(
    (state) => state.CandidateDashboardFilterDetails.CandidateDashboard.endDate
  );

  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ["#3d85c6", "#E65122", "#169c50"],
        hoverOffset: 4,
      },
    ],
  });

  // Function to fetch and update chart data
  const fetchData = async () => {
    const responseData = await GetCandidatePie(JobsFilter);
    console.log("Full responseData:", responseData);

    const interviews = responseData.interviews;

    if (Array.isArray(interviews)) {
      const filteredData = interviews.find(
        (item) =>
          String(item.admin_id).trim() === String(JobsFilter.adminId).trim()
      );

      if (filteredData) {
        const { joined_count, left_count, currently_working } = filteredData;

        // Set up labels, data, and colors conditionally
        const labels = [
          joined_count > 0 ? "Joined" : null,
          left_count > 0 ? "Left Company" : null,
          currently_working > 0 ? "Currently Working" : null,
        ].filter(Boolean); // Filter out null values

        const chartData = [
          joined_count > 0 ? parseInt(joined_count, 10) : null,
          left_count > 0 ? parseInt(left_count, 10) : null,
          currently_working > 0 ? parseInt(currently_working, 10) : null,
        ].filter(Boolean); // Filter out null values

        const backgroundColor = [
          joined_count > 0 ? "#3d85c6" : null,
          left_count > 0 ? "#E65122" : null,
          currently_working > 0 ? "#169c50" : null,
        ].filter(Boolean); // Filter out null values

        setChartData({
          labels: labels.length ? labels : ["No data available"],
          datasets: [
            {
              data: chartData.length ? chartData : [1],
              backgroundColor: backgroundColor.length
                ? backgroundColor
                : ["#e0e0e0"], // Gray for no data
              hoverOffset: 4,
            },
          ],
        });
      } else {
        console.log("No data found for the provided admin_id.");
        setChartData({
          labels: ["No data available"],
          datasets: [
            {
              data: [0],
              backgroundColor: ["#e0e0e0"], // Gray for no data
              hoverOffset: 4,
            },
          ],
        });
      }
    } else {
      console.error("Interviews data is not an array:", interviews);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JobsFilter]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
        // Customize the data labels
        color: "white", // Set text color to white
        font: {
          weight: "bold", // Make the font bold
          size: 16, // Adjust the size of the font if necessary
        },
        // Formatter to add a leading zero if the count is less than 10
        formatter: (value) => {
          return value < 10 ? `0${value}` : value; // Add leading zero if less than 10
        },
      },
    },
    cutout: "60%",
    rotation: -Math.PI / 2,
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div className="container">
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <h4 style={{ textAlign: "left" }}>Analytics</h4>
          
        </div> */}
        <div>
          {" "}
          <div className="text-center mb-1">
            <b>
              <DMMMYYYY_formate dateValue={startDate} />
            </b>{" "}
            to{" "}
            <b>
              <DMMMYYYY_formate dateValue={endDate} />
            </b>
          </div>
          <div
            style={{
              width: "390px",
              height: "390px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Doughnut data={chartData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminCandidatePieChart;
